import _ from 'lodash';

export const userActions = {
    GET_CURRENT_USER_DETAILS : 'GET_CURRENT_USER_DETAILS',

    RESET_TRYING: 'RESET_TRYING',
    RESET_PADING: 'RESET_PADING',
    RESET_SUCCESS: 'RESET_SUCCESS',
    RESET_FAILURE: 'RESET_FAILURE',
    UPDATE_USER: 'UPDATE_USER',
    GET_MODULES: 'GET_MODULES',
    SET_MODULES: 'SET_MODULES',

    SET: 'SET',

    GET_GROUP: 'GET_GROUP',

    GET_USER: 'GET_USER',
    GET_USERS: 'GET_USERS',
    ADD_USER: 'ADD_USER',
    SAVE_USER: 'SAVE_USER',
    DUPLICATE_USER: 'DUPLICATE_USER',
    SET_USER_STATUS: 'SET_USER_STATUS',
    DELETE_USER: 'DELETE_USER',
    REFRESH_DELETE_USER: 'REFRESH_DELETE_USER',
    RESET_PASSWORD: 'RESET_PASSWORD',

    GET_USER_ROLES: 'GET_USER_ROLES',
    GET_USER_GROUP_ROLES: 'GET_USER_GROUP_ROLES',
    GET_PROJECT_GROUP_ROLES: 'GET_PROJECT_GROUP_ROLES',
    GET_PROJECT_GROUP_ROLES_BY_USER_GROUP: 'GET_PROJECT_GROUP_ROLES_BY_USER_GROUP',
    SAVE_USER_ROLES: 'SAVE_USER_ROLES',
    SAVE_USER_GROUP_ROLES: 'SAVE_USER_GROUP_ROLES',
    SAVE_PROJECT_GROUP_ROLES_BY_USER: 'SAVE_PROJECT_GROUP_ROLES_BY_USER',
    SAVE_PROJECT_GROUP_ROLES_BY_USER_GROUP: 'SAVE_PROJECT_GROUP_ROLES_BY_USER_GROUP',

    GET_USER_GROUPS: 'GET_USER_GROUPS',
    ADD_USER_GROUPS: 'ADD_USER_GROUPS',
    SAVE_GROUP: 'SAVE_GROUP',
    DUPLICATE_GROUP: 'DUPLICATE_GROUP',
    DELETE_GROUP: 'DELETE_GROUP',
    REFRESH_DELETE_USER_GROUP:'REFRESH_DELETE_USER_GROUP',

    GET_ROLE: 'GET_ROLE',
    GET_ROLES: 'GET_ROLES',
    ADD_ROLE: 'ADD_ROLE',
    SAVE_ROLE: 'SAVE_ROLE',
    SAVE_ROLES: 'SAVE_ROLES',
    DUPLICATE_ROLE: 'DUPLICATE_ROLE',
    DELETE_ROLE: 'DELETE_ROLE',
    REFRESH_DELETE_ROLE:'REFRESH_DELETE_ROLE',

    GET_PERMISSIONS: 'GET_PERMISSIONS',
    GET_USERS_AND_GROUPS: 'GET_USERS_AND_GROUPS',
    SAVE_USERS_AND_GROUPS: 'SAVE_USERS_AND_GROUPS',
    GET_ALL_USERS_AND_GROUPS: 'GET_ALL_USERS_AND_GROUPS',
    GET_USERS_AND_GROUPS_FOR_PROJCET_GROUP:'GET_USERS_AND_GROUPS_FOR_PROJCET_GROUP',

    GET_DOMAINS: 'GET_DOMAINS',
    GET_DOMAIN: 'GET_DOMAIN',
    ADD_DOMAIN: 'ADD_DOMAIN',
    SYNC_ALL_USERS_PERMISSIONS: 'SYNC_ALL_USERS_PERMISSIONS',
    IS_SYNC_ENABLED: 'IS_SYNC_ENABLED',
    ASYNC_STATUS: 'ASYNC_STATUS',
    IS_SYNC_SPECIFIC_USER_PERMISSIONS_IN_PROGRESS: 'IS_SYNC_SPECIFIC_USER_PERMISSIONS_IN_PROGRESS',
    SYNC_USER_INFO: 'SYNC_USER_INFO',
    SAVE_DOMAIN: 'SAVE_DOMAIN',
    TEST_DOMAIN_CONFIGURATION: 'TEST_DOMAIN_CONFIGURATION',

    GET_PROJECT_AND_GROUPS: 'GET_PROJECT_AND_GROUPS',

    GET_PROJECT_GROUPS: 'GET_PROJECT_GROUPS',
    GET_PROJECT_GROUP: 'GET_PROJECT_GROUP',
    ADD_PROJECT_GROUP: 'ADD_PROJECT_GROUP',
    SAVE_PROJECT_GROUP: 'SAVE_PROJECT_GROUP',
    DELETE_PROJECT_GROUP: 'DELETE_PROJECT_GROUP',
    REFRESH_DELETE_PROJECT_GROUPS: 'REFRESH_DELETE_PROJECT_GROUPS',
    GET_USER_PROJECT_GROUPS: 'GET_USER_PROJECT_GROUPS',
    GET_AUTH_TYPE:'GET_AUTH_TYPE',
    GET_USAGE_INFO: 'GET_USAGE_INFO',
    // SET_USAGE_INFO: 'SET_USAGE_INFO',
    DELETE_DOMAIN: 'DELETE_DOMAIN',
    REFRESH_DELETE_DOMAIN: 'REFRESH_DELETE_DOMAIN',
    GET_PERMISSIONS_FOR_USER: 'GET_PERMISSIONS_FOR_USER',
    USER_CAN_LINK_CMS_TO_PROJECT:'USER_CAN_LINK_CMS_TO_PROJECT',
    REFRESH_USER_CAN_LINK_CMS: 'REFRESH_USER_CAN_LINK_CMS'
};

export const userErrorMessage = {
    LOGIN_SUCCESS: 'LOGIN SUCCESS',
    LOGIN_FAILURE: 'LOGIN FAILURE',
    RESET_SUCCESS: 'RESET SUCCESS',
    RESET_FAILURE: 'RESET FAILURE'
};

const initState: any = {
    group: null,
    pending: false,
    message: null
};

export class userReducer {
    public static reduce(state = initState, action: any) {
        switch (action.type) {
            case userActions.RESET_SUCCESS:
            case userActions.RESET_FAILURE:
            case userActions.RESET_PADING:
                return Object.assign({}, state, action.payload);

            case userActions.UPDATE_USER:
                return Object.assign({}, state, action.payload);

            case userActions.SET_MODULES:
                return Object.assign({}, state, action.payload);

            case userActions.GET_USERS:
                return Object.assign({}, state, { users: action.payload });

            case userActions.GET_USER_GROUPS:
                return Object.assign({}, state, { userGroups: action.payload });

            case userActions.GET_ROLES:
                return Object.assign({}, state, { roles: action.payload });

            case userActions.GET_ROLE:
                return Object.assign({}, state, { role: action.payload });

            case userActions.GET_PERMISSIONS:
                return Object.assign({}, state, { permissions: action.payload });

            case userActions.GET_GROUP:
                return Object.assign({}, state, { group: action.payload });

            case userActions.GET_USER:
                return Object.assign({}, state, { user: action.payload });

            case userActions.USER_CAN_LINK_CMS_TO_PROJECT:
                return Object.assign({}, state, { canCMS: action.payload });


            case userActions.REFRESH_USER_CAN_LINK_CMS:
                return Object.assign({}, state, { canCMS: null });

            case userActions.ADD_USER:
                return Object.assign({}, state, { users: [...state.users, action.payload], user: action.payload });

            case userActions.GET_PROJECT_AND_GROUPS:
                return Object.assign({}, state, { projectsAndGroups: action.payload });

            case userActions.GET_USERS_AND_GROUPS:
            case userActions.GET_USERS_AND_GROUPS_FOR_PROJCET_GROUP:
                return Object.assign({}, state, { usersAndGroups: action.payload });

            case userActions.GET_ALL_USERS_AND_GROUPS:
                return Object.assign({}, state, { allUsersAndGroups: action.payload });

            case userActions.SAVE_USER:
                return Object.assign({}, state, { user: action.payload });

            case userActions.DUPLICATE_USER:
                if (state.user.id == action.payload) {
                    const duplicateUser = userReducer.deepCopy(state.user);
                    duplicateUser.id = -1;
                    duplicateUser.isNew = true;
                    duplicateUser.name = 'Copy ' + duplicateUser.name;
                    const index = _.findIndex(state.users, { id: action.payload });
                    return Object.assign({}, state, {
                        users: [
                            ...state.users.slice(0, index + 1),
                            duplicateUser,
                            ...state.users.slice(index + 1, state.user.length)
                        ],
                        user:duplicateUser
                    });
                }
                return state;

            case userActions.SAVE_GROUP:
                return Object.assign({}, state, { group: action.payload });

            case userActions.SAVE_ROLE:
                return Object.assign({}, state, { role:action.payload });

            case userActions.ADD_ROLE:
                 return Object.assign({}, state, { roles: [...state.roles, action.payload], role:action.payload });

            case userActions.SAVE_ROLES:
                return Object.assign({}, state, { roles: action.payload });

            case userActions.GET_USER_ROLES:
                return Object.assign({}, state, {
                    rolesData: {
                        id: action.userId,
                        type: action.type,
                        selectedRoles: action.payload
                    }
                });

            case userActions.GET_USER_GROUP_ROLES:
                return Object.assign({}, state, {
                    rolesData: {
                        id: action.userGroupId,
                        type: action.type,
                        selectedRoles: action.payload
                    }
                });

            case userActions.GET_PROJECT_GROUP_ROLES:
                return Object.assign({}, state, {
                    rolesData: {
                        id: action.userId,
                        type:action.type,
                        selectedRoles: action.payload
                    }
                });

            case userActions.GET_PROJECT_GROUP_ROLES_BY_USER_GROUP:
                return Object.assign({}, state, {
                    rolesData: {
                        id: action.userGroupId,
                        type: action.type,
                        selectedRoles: action.payload
                    }
                });

            case userActions.SAVE_USER_ROLES:
                return Object.assign({}, state, { userRoles: action.payload });

            case userActions.SAVE_USER_GROUP_ROLES:
                return Object.assign({}, state, { groupRoles: action.payload });

            case userActions.SAVE_PROJECT_GROUP_ROLES_BY_USER:
            case userActions.SAVE_PROJECT_GROUP_ROLES_BY_USER_GROUP:
                return Object.assign({}, state, { projectGroupRoles: action.payload });

            case userActions.ADD_DOMAIN:
                return Object.assign({}, state, { domains: [...state.domains, action.payload], domain: action.payload });
            case userActions.GET_DOMAINS:
                return Object.assign({}, state, { domains: action.payload });

            case userActions.GET_DOMAIN:
            case userActions.SAVE_DOMAIN:
                return Object.assign({}, state, { domain: action.payload });
            case userActions.SYNC_ALL_USERS_PERMISSIONS:
                return Object.assign({}, state, { userGroups: action.payload });
            case userActions.SYNC_USER_INFO:
                return Object.assign({}, state, { userGroups: action.payload });
            case userActions.ADD_USER_GROUPS:
                return Object.assign({}, state, { userGroups: [...state.userGroups,action.payload],group:action.payload });

            case userActions.ADD_PROJECT_GROUP:
                return Object.assign({}, state, { projectGroups: [...state.projectGroups,action.payload],projectGroup:action.payload });

            case userActions.GET_PROJECT_GROUPS:
                return Object.assign({}, state, { projectGroups: action.payload });

            case userActions.GET_PROJECT_GROUP:
                return Object.assign({}, state, { projectGroup: action.payload });

            case userActions.SAVE_PROJECT_GROUP:
                return Object.assign({}, state, { projectGroup: action.payload });

            case userActions.DUPLICATE_GROUP:
                return Object.assign({}, state, { projectGroup: action.payload });

            case userActions.DUPLICATE_ROLE:
                return Object.assign({}, state, { role: action.payload });

            case userActions.GET_AUTH_TYPE:
                return Object.assign({}, state, { authTypes: action.payload });

            case userActions.SET_USER_STATUS:
                const copyUser = userReducer.deepCopy(state.user);
                copyUser.status = action.payload;
                return Object.assign({}, state, { user: copyUser });

            case userActions.REFRESH_DELETE_PROJECT_GROUPS:
            {
                if (state.projectsAndGroups && state.projectGroups) {
                    const projectGroups1Exists = state.projectsAndGroups.filter((item: any) => item.id != action.payload);
                    const projectGroups2Exists = state.projectGroups.filter((item: any) => item.id != action.payload);
                    return Object.assign({}, state, {
                        projectsAndGroups: projectGroups1Exists ? projectGroups1Exists : null,
                        projectGroups: projectGroups2Exists ||  null,
                        projectGroup: projectGroups2Exists ? projectGroups2Exists[0] : null
                    });
                }
                if (state.projectsAndGroups) {
                    const projectGroupsExists = state.projectsAndGroups.filter((item: any) => item.id != action.payload);
                    return Object.assign({}, state, {
                        projectsAndGroups: projectGroupsExists || null,
                        projectGroup: projectGroupsExists ? projectGroupsExists[0] : null
                    });
                }
                if (state.projectGroups) {
                    const projectGroupsExists = state.projectGroups.filter((item: any) => item.id != action.payload);
                    return Object.assign({}, state, {
                        projectGroups: projectGroupsExists || null,
                        projectGroup: projectGroupsExists ? projectGroupsExists[0] : null
                    });
                }
            }

            case userActions.REFRESH_DELETE_ROLE:
                const rolesExists = state.roles.filter((item: any) => item.id != action.payload);
                return Object.assign({}, state, {
                    roles: (rolesExists) ? rolesExists : null,
                    role: (rolesExists) ? rolesExists[0] : null
                });

            case userActions.REFRESH_DELETE_USER_GROUP:
                const userGroupsExists = state.userGroups.filter((item: any) => item.id != action.payload);
                return Object.assign({}, state, {
                    userGroups: userGroupsExists || null,
                    group: userGroupsExists ? userGroupsExists[0] : null
                });

            case userActions.REFRESH_DELETE_USER:
                const usersExists = state.users.filter((item: any) => item.id != action.payload);
                return Object.assign({}, state, {
                    users: usersExists || null,
                    user: usersExists ? usersExists[0] : null
                });

            case userActions.REFRESH_DELETE_DOMAIN:
                const domainsExists = state.domains.filter((item: any) => item.id != action.payload);
                return Object.assign({}, state, {
                    domains: domainsExists || null,
                    domain: domainsExists ? domainsExists[0] : null
                });
            case userActions.GET_PERMISSIONS_FOR_USER:
                return Object.assign({}, state, { checkingPermissions: action.payload });
            default:
                return state;
        }
    }

    public static wrapperReduce(state = initState, action: any) {
        const _state = userReducer.reduce(state, action);
        return Object.assign({}, _state, { typeAction: action.typeAction, requestParam : action.requestParam });
    }

    private static deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/userReducer.ts